import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import CostDashboard from "../Components/CostDashboard/index";
import { CheckRequestModalProvider } from "../Components/CostDashboard/CheckRequestModalContext";
import CheckRequestModal from "../Components/CostDashboard/CheckRequestModal";
import { AlertCheckNotRequestedProvider } from "../Components/CostDashboard/AlertCheckNotRequestedModalContext";
import AlertCheckNotRequested from "../Components/CostDashboard/AlertCheckNotRequestedModal";
import { CostManagementProvider } from "../Components/CostDashboard/CostManagementContext";
import { UpdateTriggerProvider } from "../Components/CostDashboard/TriggerUpdateContext";
import Footer from "../Components/common/footer";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";

function CostPage() {
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);
  const caseId = getCaseId();
  const dispatch = useDispatch();

  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 16).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  useEffect(() => {
    fetchShakespeareStatus(caseId, 16, dispatch);
  }, [caseId, dispatch]);

  return (
    <CheckRequestModalProvider>
      <AlertCheckNotRequestedProvider>
        <CostManagementProvider>
          <UpdateTriggerProvider>
            <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
              <Sidebar />
              <div className="page-container overflow-hidden">
                <NavBar flaggedPageName="16" />
                <ActionBarComponent
                  src={pageObject?.page_icon}
                  page_name={pageObject?.name}
                  pageObj={pageObject}
                  isChecklist={pageObject?.PageChklst || false}
                />
                <CostDashboard pageObject={pageObject} />
                <CheckRequestModal />
                <AlertCheckNotRequested />
              </div>
            </div>
            <Footer />
          </UpdateTriggerProvider>
        </CostManagementProvider>
      </AlertCheckNotRequestedProvider>
    </CheckRequestModalProvider>
  );
}

export default CostPage;
